<div class="auth">
  <div class="auth__glow" aria-hidden="true"></div>

  <header class="auth__top">
    <a routerLink="/" class="auth-brand" aria-label="PulseWatch home">
      <span class="auth-brand__mark" aria-hidden="true">
        <svg viewBox="0 0 64 64"><path d="M9 35h11l5-12 8 24 6-17 3 5h13" /></svg>
      </span>
      <span class="auth-brand__name">PulseWatch</span>
    </a>
    <a routerLink="/knowledge-base" class="auth__help">Help</a>
  </header>

  <main class="auth__main auth__main--single">
    <section class="auth-card">
      <h1>Create your account</h1>
      <p class="auth-card__sub">PulseWatch is invitation only for now — you'll need your invitation code.</p>

      <form [formGroup]="form" (ngSubmit)="register()" novalidate>
        <div class="auth-row">
          <label class="auth-field">
            <span>First name</span>
            <div class="auth-field__box" [class.is-invalid]="invalid('first_name')">
              <input type="text" formControlName="first_name" placeholder="Hans" autocomplete="given-name" />
            </div>
            @if (has('first_name', 'required')) {
              <small class="auth-field__error">Required.</small>
            }
          </label>

          <label class="auth-field">
            <span>Last name</span>
            <div class="auth-field__box" [class.is-invalid]="invalid('last_name')">
              <input type="text" formControlName="last_name" placeholder="Müller" autocomplete="family-name" />
            </div>
            @if (has('last_name', 'required')) {
              <small class="auth-field__error">Required.</small>
            }
          </label>
        </div>

        <label class="auth-field">
          <span>Email</span>
          <div class="auth-field__box" [class.is-invalid]="invalid('email')">
            <i class="bx bx-envelope" aria-hidden="true"></i>
            <input type="email" formControlName="email" placeholder="you@company.com" autocomplete="email" inputmode="email" />
          </div>
          @if (has('email', 'required')) {
            <small class="auth-field__error">Email is required.</small>
          } @else if (has('email', 'email')) {
            <small class="auth-field__error">Please enter a valid email address.</small>
          }
          @if (serverError('email'); as message) {
            <small class="auth-field__error">{{ message }}</small>
          }
        </label>

        <label class="auth-field">
          <span>Password</span>
          <div class="auth-field__box" [class.is-invalid]="invalid('password')">
            <i class="bx bx-lock-alt" aria-hidden="true"></i>
            <input
              [type]="showPassword() ? 'text' : 'password'"
              formControlName="password"
              placeholder="At least 5 characters, a letter and a number"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="auth-field__toggle"
              (click)="showPassword.set(!showPassword())"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
            >
              <i class="bx" [class.bx-show]="!showPassword()" [class.bx-hide]="showPassword()"></i>
            </button>
          </div>
          @if (has('password', 'required')) {
            <small class="auth-field__error">Password is required.</small>
          } @else if (has('password', 'minlength')) {
            <small class="auth-field__error">Password must be at least 5 characters.</small>
          } @else if (has('password', 'passwordNoLetter')) {
            <small class="auth-field__error">Password must contain at least one letter.</small>
          } @else if (has('password', 'passwordNoNumber')) {
            <small class="auth-field__error">Password must contain at least one number.</small>
          }
          @if (serverError('password'); as message) {
            <small class="auth-field__error">{{ message }}</small>
          }
        </label>

        <label class="auth-field">
          <span>
            Invitation code
            <i class="bx bx-info-circle auth-hint" title="PulseWatch is currently invitation only. You need a valid invitation code to register."></i>
          </span>
          <div class="auth-field__box" [class.is-invalid]="invalid('invitation_code')">
            <i class="bx bx-key" aria-hidden="true"></i>
            <input type="text" formControlName="invitation_code" placeholder="Enter your code" autocomplete="off" />
          </div>
          @if (has('invitation_code', 'required')) {
            <small class="auth-field__error">Invitation code is required.</small>
          }
          @if (serverError('invitation_code'); as message) {
            <small class="auth-field__error">{{ message }}</small>
          }
        </label>

        @if (formError()) {
          <div class="auth-alert" role="alert"><i class="bx bx-error-circle"></i>{{ formError() }}</div>
        }

        <button type="submit" class="auth-btn" [disabled]="isLoading()">
          @if (isLoading()) {
            <span class="auth-btn__spinner" aria-hidden="true"></span> Creating account…
          } @else {
            Create account <i class="bx bx-right-arrow-alt"></i>
          }
        </button>
      </form>

      <p class="auth-card__alt">Already have an account? <a routerLink="/login" class="auth-link">Log in</a></p>
    </section>
  </main>

  <footer class="auth__footer">{{ versions.hash }} · {{ versions.date | date: 'short' }}</footer>
</div>
